import styled from "styled-components";

const SubscribeContainer = styled.div`
  background: #222222;
  padding: 40px 0;
`;
export default SubscribeContainer;
